import React from 'react';
import AppContainer from '../container/AppContainer';
import DashboardContainer from '../container/DashboardContainer';

const DashboardView = (params) => (
    <AppContainer >
        <DashboardContainer />
    </AppContainer>
)

export default DashboardView;